@if (baseRules?.hasOutstanding && !isReviewPage) {
  <h2 class="axis-h4">New Jersey</h2>
  @if (reactiveForm) {
    <form [formGroup]="reactiveForm">
      <!--PIP Coverage-->
      <h3 class="axis-h5 _mt-medium">{{ textValues?.["PIP_Coverage_Text"] }}</h3>
      <!--TRUCK ONLY/NO Selection-->
      <div
        class="axis-form-group _mt-medium"
        [ngClass]="{
          'has-axis-required': reactiveForm.get(controls[16].formControlName)?.value === '',
          'has-axis-error':
            reactiveForm.get(controls[16].formControlName)?.touched &&
            reactiveForm.get(controls[16].formControlName)?.invalid,
        }"
      >
        @if (controls?.length >= 16) {
          <axis-radio-button-wrapper formControlName="{{ controls[16].formControlName }}">
            @for (control of controls[16].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[16].formControlName }}"
              ></axis-radio>
            }
            @if (reactiveForm.get(controls[16].formControlName)?.touched) {
              @if (reactiveForm.get(controls[16].formControlName)?.invalid) {
                <span
                  class="axis-error-block"
                  role="alert"
                  >Please select an option.</span
                >
              }
            }
          </axis-radio-button-wrapper>
        }
      </div>
      <!--Main Form-->
      <div class="axis-form-group _mt-medium">
        <!--Read Only Values-->
        @if (baseRules["show_readonly"] === true) {
          <!-- Main Text -->
          <div class="axis-form-group _mt-medium">
            <label class="axis-control-label">
              {{ textValues?.["Main_Text"] }}
            </label>
          </div>

          <!-- Refer Text -->
          <div class="axis-form-group _mt-medium">
            <p>
              {{ textValues?.["Refer_Text"] }}
            </p>
          </div>
          <!-- Sub_Text -->
          <div class="axis-form-group _mt-medium">
            <label class="axis-control-label">
              {{ textValues?.["Sub_Text"] }}
            </label>
          </div>
          <!-- Medical Expense Benefits Text -->
          <div class="axis-form-group _mt-medium">
            <p>
              {{ textValues?.["Medical_Expense_Benefits_Text"] }}
            </p>
          </div>

          <!-- Medical Expense Amount Text with additional spacing -->
          <div class="axis-form-group _mt-medium">
            <p class="_ml-large">
              {{ textValues?.["Medical_Expense_Amount_Text"] }}
            </p>
          </div>

          <!-- Extended Medical Expense Text -->
          <div class="axis-form-group _mt-medium">
            <p>
              {{ textValues?.["Extended_Medical_Expense_Text"] }}
            </p>
          </div>
        }

        <!--Medical Expense Check Box-->
        @if (baseRules["extendedMedicalExpenseBenefits_Checkbox"]?.includes("show")) {
          <div class="axis-grid _mt-large">
            <div class="_ml-medium _mb-medium">
              <axis-checkbox
                [formControlName]="controls[0].formControlName"
                [heading]="controls[0].label"
              ></axis-checkbox>
            </div>
          </div>
        }
        <!--Read Only Medical Expense-->
        @if (baseRules["extendedMedicalExpenseBenefits_Checkbox"]?.includes("Yes")) {
          <div class="axis-grid _mt-large">
            <div class="_ml-medium _mb-medium">
              <label class="axis-control-label">
                {{ controls[0].label }}
              </label>
              <div>
                {{ textValues?.["Yes_Text"] }}
              </div>
            </div>
          </div>
        }
        <!--Medical Expense Radio-->
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[1].formControlName)?.value === '',
            'has-axis-error':
              reactiveForm.get(controls[1].formControlName)?.touched &&
              reactiveForm.get(controls[1].formControlName)?.invalid,
          }"
        >
          @if (controls?.length >= 1) {
            @if (baseRules["show_label"] === true) {
              <label class="axis-control-label">
                {{ controls[1].label }}
                <span
                  aria-hidden="true"
                  class="axis-required-indicator"
                  >*</span
                >
              </label>
            }

            <axis-radio-button-wrapper formControlName="{{ controls[1].formControlName }}">
              @for (control of controls[1].option; track $index) {
                <axis-radio
                  [hidden]="getRadioButtons(control)"
                  class="{{ control.class }}"
                  heading="{{ control.label }}"
                  value="{{ control.select }}"
                  name="{{ controls[1].formControlName }}"
                ></axis-radio>
              }
              @if (reactiveForm.get(controls[1].formControlName)?.touched) {
                @if (reactiveForm.get(controls[1].formControlName)?.invalid) {
                  <span
                    class="axis-error-block"
                    role="alert"
                    >Please select an option.</span
                  >
                }
              }
            </axis-radio-button-wrapper>
          }
        </div>
      </div>
    </form>
  }
}
@if (baseRules && !baseRules?.hasOutstanding && isReviewPage) {
  <h2 class="axis-h4">New Jersey</h2>
  @if (baseRules?.Only_Pedestrian_PIP_Coverage === "Yes") {
    <div class="axis-form-group">
      <label class="axis-control-label">{{ textValues?.Only_Pedestrian_PIP_Coverage_Text }}</label>
    </div>
  }
}
